module.exports = __webpack_public_path__ + "media/images/thumb/map-marker-default-45de88ff336d7c6b306d340780a175ba.png";